<template lang="html">
  <div id="presion" class="container-fluid">
    <div id="main" style="width: ;" 600px;height:400px;></div>
  </div>
</template>

<script>

var echarts = require('echarts');
// initialize echarts instance with prepared DOM
export default {
  data() {
    return {};
  },
  computed: {},
  components: {

  },
  mounted() {
    
  }
}
 
</script>

<style lang="scss" scoped>
@import "~varmix";
.container-fluid {
  margin: 0;
  padding: 0;
}
#presion {
  background-color: $bg;
  #formulario-top {
    height: 10vh;
    margin-top: 80px;
    border-bottom: 1px solid $inactive;
  }

  #graficas {
    height: 65vh;
  }

  .btn-default {
    margin-top: 0;
    background-color: $amarilloC;
    &:hover,
    &:active,
    &:focus {
      background-color: $amarilloO !important;
    }
  }
}
.nomen {
  height: 100%;
  border-right: 3px solid gray;
  text-align: center;
}

table,
.panel-body {
  overflow: scroll;
  height: 32vh;
  // width: 50vw;
  padding: 0px 0 0 0;
  border-bottom: 1px solid #999;
  margin: 20px 0px;
  @include tablet {
    padding: 0;
  }
  .info {
    td {
      background-color: $bg;
    }
  }
  th {
    text-align: left;
    padding-left: 25px;
    @include cMax(415px) {
      font-size: 12px;
    }
  }
  td {
    text-align: left;
    padding-left: 25px;
    i {
      color: $inactive;
      cursor: pointer;
      &:hover {
        color: $amarilloC;
      }
    }
  }
  .nombre-alarma {
    background-color: $amarilloC;
    color: white;
  }
  .panel-body {
    padding: 0;
  }
  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// test.vue?45101445